import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { Application } from '../../../models/admin-models';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { FormControl, FormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-group-schema',
  templateUrl: './group-schema.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    MatRadioModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class GroupSchemaComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private snacky = inject(MatSnackBar);

  @Input() applications: Application[];
  @Output() toggleLoading = new EventEmitter();
  groupSchema: {
    solution: null | string;
    group: null | string;
    response: boolean;
  } = {
    solution: null,
    group: null,
    response: false,
  };
  unitsControl = new FormControl();
  filteredUnits;
  selectedUnit;

  ngOnInit(): void {
    this.getUnits();
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id.toLowerCase() === this.unitsControl.value.toLowerCase();
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  autoCompleteUnitChanged(ev) {
    this.unitsControl.setValue(ev.option.value);
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSrvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }

  getGroupSchema() {
    this.toggleLoading.emit();
    this.admnSrvc.getGroupSchema(this.groupSchema).subscribe({
      next: resp => {
        let fileData;
        const filename = `${this.groupSchema.solution}-${
          this.groupSchema.group
        }-GroupSchema.${this.groupSchema.response ? 'csv' : 'json'}`;
        const reader = new FileReader();
        reader.readAsDataURL(resp.body);

        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename);
        };
        this.toggleLoading.emit();
      },
      error: () => {
        this.snacky.open(
          `Oops! Something went wrong, please check your parameters and try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
        this.toggleLoading.emit();
      },
    });
  }
}
